export const GET_FILE_IMPORT_DATA = 'GET_FILE_IMPORT_DATA';
export const SET_FILE_IMPORT_DATA = 'SET_FILE_IMPORT_DATA';
export const COMPOSE_FILE_IMPORT_DATA = 'COMPOSE_FILE_IMPORT_DATA';
export const SET_FILE_IMPORT_DATA_MODEL = 'SET_FILE_IMPORT_DATA_MODEL';
export const IMPORT_FILE_DATA = 'IMPORT_FILE_DATA';
